import { useQuery } from '@tanstack/react-query';

import { fetchFn } from '@/lib/react-query';

interface Params {
  userId: number;
  types: string[];
  ownerCodes: string[];
}

interface Filters {
  garbage?: { id: number; name: string }[];
  itemType?: { id: number; name: string }[];
  kojv?: { id: number; name: string }[];
  contracts?: { id: number; contractNumber: string }[];
  addresses?: { id: number; address: string }[];
  objects?: { id: number }[];
}

const getFiltersFn = <T>({ userId, types, ownerCodes }: Params): Promise<T> =>
  fetchFn(`/self-service/customers/${userId}/filters`, {
    params: {
      types,
      ownerCodes,
    },
  });

export const useGetFilters = (params: Params) => {
  return useQuery<Filters>({
    queryKey: ['filters', params],
    queryFn: () => getFiltersFn(params),
  });
};
